<template>
<!--  <div id="app" :style="{filter:$route.name === 'homeIndex' ? 'grayscale(100%)' : ''}">-->
  <div id="app" >
    <router-view/>
    <!-- <el-container>
       <el-header>
         <div class="TopContainer">
           <ul class="TopHeader">
              <li v-for="item in titleList" :key="item.title" @click="toUrl(item.url)">{{item.title}}</li>
           </ul>
         </div>
       </el-header>
       <el-main>

       </el-main>
     &lt;!&ndash;  <el-footer style="height: auto;position: fixed;bottom:0;width: 100%;">
         <div>@煜策星</div>
       </el-footer>&ndash;&gt;
     </el-container>-->
  </div>
</template>

<script>
  import Vue from "vue";

  export default {
    name: 'App',
    data () {
      return {
        f:false,
        titleList: [
          {
            title: '我的问卷',
            url: '/'
          },
          {
            title: '问卷类型'
          }
        ],

      }
    },
    methods: {
      toUrl (url) {
        this.$router.push(url)
      }
    },
    created(){
      // window.addEventListener('message', (event) => {
      //   console.log(event,'event')
      //   let gwjToken = localStorage.getItem('token');
      //   console.log(gwjToken,'gwjToken')
      //   if (event.data.data) {
      //     let data = event.data.data;
      //     let token = JSON.parse(data);
      //     if(token.token){
      //       localStorage.setItem('token','Bearer '+token.token)
      //       localStorage.setItem('username',token.username)
      //     }
      //   }
      // })
    }
  /*  watch:{
      $route(newVal,oldVal){
        debugger
      }
    }*/
  }
</script>

<style>
  @import "./assets/scss/index.scss";
  body, *, html {
    padding: 0;
    margin: 0;
  }
  body,html{
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    color:#333;
    background:#f1f2f4;
  }
  .__view{
    width:-webkit-fill-available !important;
  }

  .TopContainer {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .TopHeader {
    list-style-type: none;
    overflow: hidden;
  }

  .TopHeader > a {
    font-size: 14px;
    float: left;
    padding: 0 10px;
    height: 60px;
    line-height: 60px;
    color: #707070;
  }

  .TopHeader > a:hover {
    color: #409EFF;
    cursor: pointer;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }

  /* 滚动条的滑轨背景颜色 */
  ::-webkit-scrollbar-track {
    background-color: #f1f2f4;
  }

  /* 滑块颜色 */
  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 10px;
  }

  @media screen and (max-width: 1400px) and (min-width: 700px) {

  }
  .el-rate__item .el-rate__icon{
    font-size: 30px !important;
  }
  .el-rate{
    height:30px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue